import React from 'react';
import * as S from './styles';
import { InputLabelProps } from './types';

/**
 * Label for form input fields
 */
export const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(
  ({ children, ...props }, ref) => (
    <S.Root {...props} ref={ref}>
      {children}
    </S.Root>
  ),
);

export default InputLabel;
